export default __webpack_public_path__ + "static/media/default-service-background.f52d76e9.png";